// db.js
import Dexie from "dexie";

const db = new Dexie("ZOA_OPD_DB");

db.version(2).stores({
  members: `
    ++id,
    opdId,
    firstName,
    middleName,
    lastName,
    gender,
    dateOfBirth,
    phoneNumber,
    email,
    location,
    subCity,
    kebele,
    woreda,
    specificLocation,
    disabilityType,
    disabilityOther,
    educationLevel,
    disabilityDescription,
    maritalStatus,
    numberOfFamilies,
    employmentStatus,
    supportNeeded,
    supportReceived,
    idType,
    idNumber,
    createdAt
  `,
  opds: `
    ++id,
    opdId,
    name,
    registrationNumber,
    contactPerson,
    contactPhone,
    contactEmail,
    address,
    subCity,
    kebele,
    woreda,
    establishedDate,
    servicesProvided,
    createdAt,
    updatedAt
  `,
  users: `++id,email,passwordHash,rememberMe`, // new users table
});
// Add conversations & messages in version 3
db.version(3).stores({
  members: `++id,opdId,firstName,middleName,lastName,gender,dateOfBirth,phoneNumber,email,location,subCity,kebele,woreda,specificLocation,disabilityType,disabilityOther,educationLevel,disabilityDescription,maritalStatus,numberOfFamilies,employmentStatus,supportNeeded,supportReceived,idType,idNumber,createdAt`,
  opds: `++id,opdId,name,registrationNumber,contactPerson,contactPhone,contactEmail,address,subCity,kebele,woreda,establishedDate,servicesProvided,createdAt,updatedAt`,
  users: `++id,email,passwordHash,rememberMe`,
  conversations: "++id,conversationId,lastMessageAt,members,isGroup,name",
  messages: "++id,conversationId,senderEmail,createdAt,read",
});
db.version(4).stores({
  members: `++id,opdId,firstName,middleName,lastName,gender,dateOfBirth,phoneNumber,email,location,subCity,kebele,woreda,specificLocation,disabilityType,disabilityOther,educationLevel,disabilityDescription,maritalStatus,numberOfFamilies,employmentStatus,supportNeeded,supportReceived,idType,idNumber,createdAt`,
  opds: `++id,opdId,name,registrationNumber,contactPerson,contactPhone,contactEmail,address,subCity,kebele,woreda,establishedDate,servicesProvided,createdAt,updatedAt`,
  users: `++id,email,passwordHash,rememberMe,status,lastSeen`, // Added status and lastSeen
  conversations: "++id,conversationId,lastMessageAt,members,isGroup,name",
  messages: "++id,conversationId,senderEmail,createdAt,read",
});
db.version(5).stores({
  members: `++id,opdId,firstName,middleName,lastName,gender,dateOfBirth,phoneNumber,email,location,subCity,kebele,woreda,specificLocation,disabilityType,disabilityOther,educationLevel,disabilityDescription,maritalStatus,numberOfFamilies,employmentStatus,supportNeeded,supportReceived,idType,idNumber,createdAt`,
  opds: `++id,opdId,name,registrationNumber,contactPerson,contactPhone,contactEmail,address,subCity,kebele,woreda,establishedDate,servicesProvided,createdAt,updatedAt`,
  users: `++id,email,passwordHash,rememberMe,status,lastSeen`,
  conversations: "++id,conversationId,lastMessageAt,members,isGroup,name",
  messages: "++id,conversationId,senderEmail,createdAt,read",
  opdSupports: `++id,opdId,opdName,supportType,amount,dateGiven,notes`
});

db.version(6).stores({
  members: `++id,opdId,firstName,middleName,lastName,gender,dateOfBirth,phoneNumber,email,location,subCity,kebele,woreda,specificLocation,disabilityType,disabilityOther,educationLevel,disabilityDescription,maritalStatus,numberOfFamilies,employmentStatus,supportNeeded,supportReceived,idType,idNumber,createdAt`,
  opds: `++id,opdId,name,registrationNumber,contactPerson,contactPhone,contactEmail,address,subCity,kebele,woreda,establishedDate,servicesProvided,createdAt,updatedAt`,
  users: `++id,email,passwordHash,rememberMe,status,lastSeen`,
  conversations: "++id,conversationId,lastMessageAt,members,isGroup,name",
  messages: "++id,conversationId,senderEmail,createdAt,read",
  opdSupports: `++id,opdId,opdName,supportType,amount,dateGiven,notes`
});

db.version(7).stores({
  members: `++id,opdId,firstName,middleName,lastName,gender,dateOfBirth,phoneNumber,email,location,subCity,kebele,woreda,specificLocation,disabilityType,disabilityOther,educationLevel,disabilityDescription,maritalStatus,numberOfFamilies,employmentStatus,supportNeeded,supportReceived,idType,idNumber,createdAt`,
  opds: `++id,opdId,name,registrationNumber,contactPerson,contactPhone,contactEmail,address,subCity,kebele,woreda,establishedDate,servicesProvided,createdAt,updatedAt`,
  users: `++id,email,passwordHash,rememberMe,status,lastSeen`,
  conversations: "++id,conversationId,lastMessageAt,members,isGroup,name",
  messages: "++id,conversationId,senderEmail,createdAt,read",
  opdSupports: `++id,opdId,opdName,supportType,amount,dateGiven,notes`
});

db.version(9).stores({
  members: `++id,opdId,firstName,middleName,lastName,gender,dateOfBirth,phoneNumber,email,location,subCity,kebele,woreda,specificLocation,disabilityType,disabilityOther,educationLevel,disabilityDescription,maritalStatus,numberOfFamilies,employmentStatus,supportNeeded,supportReceived,idType,idNumber,createdAt`,
  deletedMembers: `++id,opdId,firstName,middleName,lastName,gender,dateOfBirth,phoneNumber,email,location,subCity,kebele,woreda,specificLocation,disabilityType,disabilityOther,educationLevel,disabilityDescription,maritalStatus,numberOfFamilies,employmentStatus,supportNeeded,supportReceived,idType,idNumber,createdAt,deletedAt`,
  opds: `++id,opdId,name,registrationNumber,contactPerson,contactPhone,contactEmail,address,subCity,kebele,woreda,establishedDate,servicesProvided,createdAt,updatedAt`,
  users: `++id,email,passwordHash,rememberMe,status,lastSeen`,
  conversations: "++id,conversationId,lastMessageAt,members,isGroup,name",
  messages: "++id,conversationId,senderId,content,createdAt,status",
  files: "++id,conversationId,fileName,fileType,fileSize,fileUrl,uploadedBy,uploadedAt",
  passwordResetTokens: `++id,email,token,expiresAt,used,createdAt`
});

// Version 10: Add offlineMembers queue store for offline registrations
db.version(10).stores({
  offlineMembers: `++id,firstName,middleName,lastName,gender,dateOfBirth,age,phoneNumber,email,location,subCity,houseNumber,woreda,specificLocation,disabilityType,disabilityOther,disabilityDescription,educationLevel,maritalStatus,numberOfFamilies,employmentStatus,workPlace,officeName,workType,jobResponsibility,labourID,labourIDNumber,supportNeeded,workNeeded,supportReceived,idType,idNumber,opdEmail,createdAt`
});

export default db;
